module.exports = __webpack_public_path__ + "static/media/outlet-role-assignment.4be36610.svg";